import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { CommonService } from "../../../app/services/common.service";
import { HttpClient } from "@angular/common/http";
import { HttpResponse } from "@angular/common/http";
import { BaseComponent } from "../../../app/pages/base.component";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
@Component({
  selector: "app-payment-gateway-for-tnt-reg",
  templateUrl: "./payment-gateway-for-tnt-reg.component.html",
  styleUrls: ["./payment-gateway-for-tnt-reg.component.css"],
})
export class PaymentGatewayForTntRegComponent extends BaseComponent implements OnInit {
  @ViewChild("myIframe") myIframe: ElementRef;
  innerHmtl: any = "";
  servicesbyCurrency: Array<any> = [];
  isPaymentVisible: boolean = false;
  isPayment: boolean = true;
  serviceName: string = "";
  countryId: any = localStorage.getItem("countryID");
  amount: any;
  paymentType: any;
  email: any = '';
  screenType: any = '';
  redirectTimer: any;
  userInfo = {
    HashKey: "",
    billRefNumber: "",
    clientName: "",
    clientidnumber: "",
    CURRENCY: "",
    amount: 0,
    billdesc: "",
    clientMobile: "",
    serviceId: "",
    apiClientId: "",
    callbackUrl: "",
    NotificationUrl: "",
    UserName: "",
    Ouk_img: "",
    callBackURLOnSuccess: "",
  };
  paymentSuccess: any;
  COURSEID: any;
  type: any;
  tantName: any;
  workItemId: any;
  courseYearId: any;
  staticTenantCode: any;
  status: any;

  constructor(
    private http: HttpClient,
    CommonService: CommonService,
    toastr: ToastrService,
    private route: Router,
    private active: ActivatedRoute) {
    super(CommonService, toastr);
    this.active.queryParams.subscribe((res: any) => {
      // this.userInfo = res.id;
      // this.amount = atob(res.amt);
      this.type = res.typ;
      this.paymentType = res.typ;
      this.COURSEID = res.cId;
      this.workItemId = res?.wId;
      this.courseYearId = res?.cyId;
      this.staticTenantCode = res?.stTnt;
      this.status = res?.sts;
      this.userId = res?.uId;
      this.tantName = res?.tntName;
      this.email = res?.email;
      this.screenType = res?.screen;
      if (this.type == 9) {
        // this.userInfo.amount = +localStorage.getItem("courseFee")!;
        this.countryId = res.countryId;
      }
      // this.loadPayeDetails();
    });
    this.userInfo = this.CommonService.paymentHashkeyobj;
  }
  ngOnInit(): void {
    this.loadPayeDetails();
    window.scrollTo({ top: 0, behavior: "smooth" }); // or 'auto' for instant

    // this.getServicesbyCurrency();
  }

  Submit() {
    if (["10"].includes(this.paymentType) && this.userInfo.amount != 0) {
      this.activeSpinner();
      this.isPaymentVisible = true;
      this.makePayment();
      this.deactivateSpinner();
    } else {
      this.activeSpinner();
      if (this.paymentType == "10") {
        this.CommonService.postCall(
          "StudentTransferRequest/UpdateTenantPaymentStatus",
          {
            TNT_CODE: this.staticTenantCode,
          }
        ).subscribe(
          (res: any) => {
            // this.toastr.success("Payment Successful");

            this.openModal();   // ✅ Show modal instead of navigate
            this.deactivateSpinner();

            this.deactivateSpinner();
          },
          (e) => {
            this.toastr.error(e?.error?.message);
            this.deactivateSpinner();
          }
        );
      }
    }
  }

  openModal() {
    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('myModal')
    );
    modal.show();
    this.redirectTimer = setTimeout(() => {
    this.okButton();
  }, 20000);
  }

  okButton() {
    const modalElement = document.getElementById('myModal');
    const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
    modal.hide();

    this.route.navigate(['/landingPage']);  // ✅ Navigate on OK click
  }
  makePayment() {
    this.activeSpinner();
    document.getElementById("payButton")?.click();
    this.isPayment = false;
    this.deactivateSpinner();
  }

  back() {
    // window.history.back();
    if (this.screenType == 'IR') {
      this.route.navigate(["/institution-reg"], { queryParams: { screen: this.screenType, email: this.email } });
    } else {
      window.history.back();
    }
  }

  loadPayeDetails() {
    let payload = {
      userId: this.userId,
      TNT_CODE: this.paymentType == "10" ? 12345678 : +localStorage.TenantCode,
      // this.countryId == 336 ? "KES" : "USD"
      currency: "KES",
      paymenttype: this.type == 6 ? 6 : +this.paymentType,
      courseid: +this.COURSEID || 0,
      // amount: this.paymentType == "10" ? 1 : +this.userInfo.amount || 0,
      amount: +this.userInfo.amount || 0,
      IsKuccps: localStorage.getItem("IsKuccsps") === "true",
      schoolTenant: +this.staticTenantCode,
    };

    this.activeSpinner();
    this.CommonService.postCall("Payment/GenerateHashKey", payload).subscribe(
      (res: any) => {
        if (res) {
          this.userInfo = res;
          if (this.tantName && this.tantName.trim() !== '') {
            this.userInfo.clientName = this.tantName.trim();
          }
          console.log("clientName:", this.userInfo.clientName);

        }

        this.deactivateSpinner();
        // console.log(res);
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }
  get formattedAmount(): string {
    return this.userInfo.amount !== null
      ? this.userInfo?.amount?.toFixed(2)
      : "0.00";
  }

  set formattedAmount(value: string) {
    this.userInfo.amount = parseFloat(value.replace(/,/g, "")) || 0;
  }

  getServicesbyCurrency() {
    let payload = {
      pg_currency: 1,
      pg_tnt_code: this.staticTenantCode,
    };
    this.CommonService.postCall(
      "Payment/GetPgServicesbyCurrencyId",
      payload
    ).subscribe((res: any) => {
      this.servicesbyCurrency = res;
    });
  }
}
